import React from 'react';
import {
  AdornedInput,
  Adornment,
  Flex,
  Input,
  Paragraph,
  // @ts-expect-error
  Range,
  Text,
  Tooltip,
  TooltipPopper,
} from '@zillow/constellation';

// Misc / utils
import * as S from './styles';
import type { InputAndSliderProps } from './../types';

interface adornedInputPropsType {
  input: React.ReactNode;
  leftAdornment?: React.ReactNode;
  rightAdornment?: React.ReactNode;
  style: { width: string };
}

const InputAndSlider: React.FC<React.PropsWithChildren<React.PropsWithChildren<InputAndSliderProps>>> = ({
  title,
  min,
  max,
  step,
  value,
  leftAdornment,
  rightAdornment,
  onChange,
  tooltipText,
}: InputAndSliderProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    onChange(value);
  };

  const adornedInputProps: adornedInputPropsType = {
    input: <Input size="sm" fluid={false} value={value} onChange={handleChange} />,
    style: { width: '150px' },
  };
  if (leftAdornment) {
    adornedInputProps.leftAdornment = <Adornment>{leftAdornment}</Adornment>;
  }
  if (rightAdornment) {
    adornedInputProps.rightAdornment = <Adornment>{rightAdornment}</Adornment>;
  }

  const tooltip = <Tooltip body={<Paragraph>{tooltipText}</Paragraph>} />;

  return (
    <S.SliderInputContainer paddingY="md">
      <Flex display="flex" justifyContent="space-between" alignItems="center" marginBottom="md">
        <Text fontType="bodySmallHeading" as="h4">
          {title}
          {' '}
          <TooltipPopper triggered={tooltip} />
        </Text>
        <AdornedInput {...adornedInputProps} />
      </Flex>
      <Range min={min} max={max} value={value} onChange={handleChange} step={step} />
    </S.SliderInputContainer>
  );
};

export default InputAndSlider;
